import {EventBus} from '~/composables/bus';

export default defineNuxtRouteMiddleware(() => {
    if (process.client) {
        EventBus.$emit('hide_tooltip')
    }
})
